<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title_flex">
        <div class="componentSty_content_title">
        <span class="fonints">代理简称</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.shortname"
          clearable
        >
        </el-input>
        <span class="fonints">代理名称</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.name"
          clearable
        >
        </el-input>
        
        
      </div>
      <div class="componentSty_content_title_flex_button"><button class="buttons" @click="selectlist">查询</button></div>
      </div>
      
      <div class="componentSty_content_table" style="border:none">
        <el-table
         height="80%"
          :data="arrlist.list"
          style="width: 100%; height: 80%"
          @sort-change="sortchange"
          border
        >
          <el-table-column show-overflow-tooltip :render-header="renderHeader"
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" sortable="custom" label="申请时间" prop="gmt_create">
            <template v-slot="res">
              {{ mydateFormat(res.row.gmtCreate,"时分秒") }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="shortname" label="代理简称"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="name" label="代理名称"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="telephone" label="代理电话"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="address" label="地址"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="操作">
            <template v-slot="res">
              <span
                class="iconfont icon-xiugai"
                @click="itemparticulars(res.row)"
              ></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations" v-show="arrlist.list && arrlist.list.length">
          <el-pagination
            :page-size="conditions.limit"
            layout="total,prev, pager,next, jumper"
            :total="arrlist.totalCount"
             :current-page="conditions.page"
            @current-change="getarrlist"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake } from "@/plugins/other.js";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      listitem: [{ name: "代理管理" }, { name: "新增审核" }],
      conditions: {},
      selectitem: {
        page: 1, //当前页码
        limit: 20, //每页显示条数
        shortname: "",
        name: "",
      },
      arrlist: {},
      timeout: null,
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  components: {
    mTitle,
  },
  created() {
    this.conditionsList[this.$route.path] ||
      this.createConditions({
        key: this.$route.path,
        val: {
          page: 1,
          limit: 20,
          sidx: "gmt_create", //排序字段
          order: "desc",
        },
      });
    this.conditions = this.conditionsList[this.$route.path] || {
      page: 1,
      limit: 20,
      sidx: "gmt_create", //排序字段
      order: "desc",
    };
    this.getarrlist();
  },
  methods: {
      ...mapMutations(["createConditions"]),
    async getarrlist(num) {
      typeof num === "number" && (this.conditions.page = num);
      const { data } = await this.$http(
        "api1",
        "/fleet/fleetfleetmessage/portAuditFleetList",
        "get",
        this.conditions
      );
      if (!data) return this.$message.error("获取数据失败");
      this.arrlist = data.data;
    },
    selectlist() {
      antiShake((_) => {
        this.selectitem.page = 1;
        this.getarrlist();
      });
    },
    sortchange(event) {
      if (event.order == "ascending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "asc";
      } else if (event.order == "descending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "desc";
      } else {
        this.conditions.sidx = "";
        this.conditions.order = "";
      }
      this.getarrlist();
    },
    handleCurrentChange(index) {
      if (this.arrlist.totalCount < this.selectitem.limit) return;
      this.selectitem.page = index;
      this.getarrlist();
    },
    itemparticulars(res) {
      window.sessionStorage.setItem("infoid", res.id);
      this.$router.push({ name: "newaddcheck2" });
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>